var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99831 20C4.48491 19.9966 0 15.5151 0 10.0017C0 4.48155 4.49502 -0.0100993 10.0118 1.70549e-05C15.5286 0.0101334 20.0067 4.49504 20 10.0051C19.9932 15.5218 15.5117 20 9.99831 20ZM12.2677 9.21262C12.1565 9.21262 12.089 9.21262 12.0216 9.21262C9.99831 9.21262 7.97504 9.21262 5.95178 9.21262C5.85061 9.21262 5.74945 9.21937 5.65166 9.23623C5.0784 9.33402 4.812 10.0118 5.15596 10.4805C5.34817 10.7436 5.61457 10.8211 5.92143 10.8211C7.95481 10.8211 9.98819 10.8211 12.0249 10.8211C12.089 10.8211 12.1497 10.8211 12.2543 10.8211C11.7956 11.2831 11.3708 11.708 10.9459 12.1295C10.7402 12.3352 10.5244 12.5342 10.3254 12.75C9.93424 13.1715 10.0624 13.8054 10.5749 14.0449C10.8919 14.1932 11.2325 14.1157 11.5259 13.8223C12.5813 12.7702 13.6368 11.7215 14.6889 10.6694C15.1104 10.2512 15.1071 9.75553 14.6889 9.33739C13.6469 8.29878 12.605 7.2568 11.563 6.21819C11.5023 6.15749 11.4416 6.10016 11.3741 6.04958C10.9661 5.74272 10.3524 5.91133 10.1635 6.38679C10.0152 6.75773 10.1265 7.06796 10.3962 7.33436C10.9695 7.90762 11.5427 8.4775 12.1126 9.05076C12.1565 9.0946 12.1969 9.13844 12.2677 9.21262Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.da3ad23b7b0030adbb324fc25561a8c4.svg";
export { ForwardRef as ReactComponent };